<script setup lang="ts">
// generated from file:///input/au_src/shop/pages/legal/toc.ts
/*─────────────────────────────────────┐
│   props                              │
└─────────────────────────────────────*/
/*─────────────────────────────────────┐
│   composables                        │
└─────────────────────────────────────*/
/*─────────────────────────────────────┐
│   refs                               │
└─────────────────────────────────────*/
/*─────────────────────────────────────┐
│   setup                              │
└─────────────────────────────────────*/
</script>

<!-- generated from file:///input/au_src/shop/pages/legal/toc.html -->
<template>
    <div class="container legal-text">
        <div class="breadcrumb">
            <RouterLink class="breadcrumb-item" :to="{ name: 'home' }">Home</RouterLink>
            <div class="breadcrumb-item">AGB</div>
        </div>

        <h1>Allgemeine Geschäftsbedingungen</h1>

        <h1>1. Allgemeines</h1>

        <h2>1.1 Anbieterkennzeichnung; Geltungsbereich; AGB des Kunden</h2>

        <p>
            Diese Allgemeinen Geschäftsbedingungen (meine „AGB“) gelten für alle Verträge, die zwischen Ihnen, meinen
            Kunden (im Folgenden „Sie“ oder „Kunde(n)“) und mir,
            <b>Apotheker Björn Schrage e.K.</b>
            , eingetragen im Handelsregister des Amtsgerichts Hamburg HRA 116856, Inhaber der
            <b>apotheke am inselpark e.K.</b>
            , Neuenfelder Straße 31, 21109 Hamburg, Telefon: +49 (40) 302386990, Fax: +49 (40) 3023869920, E-Mail:
            info@apotheke-inselpark.de, USt. ID Nr.: DE 274975656 im Fernabsatz abgeschlossen werden, insbesondere über
            die unter den Internetseiten
            <b>https://cann24.de/</b>
            (meine „Internetseiten“) betriebene Versandapotheke (mein „Onlineshop“).
        </p>

        <p>
            Meine AGB in der zum Zeitpunkt der Bestellung gültigen Fassung gelten ausschließlich. Entgegenstehende oder
            von meinen AGB abweichende Allgemeine Geschäftsbedingungen des Kunden erkenne ich nicht an, es sei denn, ich
            stimme ihrer Geltung ausdrücklich schriftlich zu.
        </p>

        <h2>1.2 Kundenkreis</h2>

        <p>
            Meine Angebote im Online-Shop und diese AGB gelten ausschließlich gegenüber Verbrauchern, die das 18.
            Lebensjahr vollendet haben. „Verbraucher“ im Sinne § 13 des Bürgerlichen Gesetzbuchs („BGB“) ist jede
            natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen
            noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können. „Unternehmer“ im Sinne § 14 BGB
            ist demgegenüber eine natürliche oder juristische Person oder eine rechtsfähige Personengesellschaft, die
            bei Abschluss eines Rechtsgeschäfts in Ausübung ihrer gewerblichen oder selbständigen beruflichen Tätigkeit
            handelt.
        </p>

        <h1>2. Vertragsschluss</h1>

        <h2>2.1 Bestellprozess</h2>

        <p>
            Bestellungen sind per Post, per E-Mail, per Telefon, per Online-Shop oder per Fax möglich. Die wesentlichen
            Merkmale der jeweiligen Ware können Sie ihrer Artikelbeschreibung meines Onlineshops entnehmen. Die
            Darstellung meines Apothekensortiments und deren Bewerbung ist (unbeschadet Ziff. 6.5 dieser AGB – Lieferung
            von apotheken- und verschreibungspflichtigen Arzneimitteln) freibleibend und unverbindlich, d.h. sie stellen
            nur eine Aufforderung an Sie zur Abgabe eines Antrags auf Abschluss eines entsprechenden Kaufvertrages dar
            („Bestellung“), der meiner Annahme bedarf. Sie können aus meinem Apothekensortiment Ware auswählen und diese
            über die Schaltfläche „in den Warenkorb legen“ in einem so genannten elektronischen Warenkorb („Warenkorb“)
            sammeln. Alternativ haben Sie die Möglichkeit auch eine Bestellung per Post, Fax, E-Mail oder Telefon
            vorzunehmen, indem Sie mir über diesen Weg die von Ihnen gewünschten Waren nennen.
        </p>

        <h2>2.2 Zustandekommen des Kaufvertrages</h2>

        <p>
            Vor Abschicken der Bestellung über den Online-Shop können Sie die Daten jederzeit korrigieren, indem Sie die
            hierfür im Bestellablauf vorgesehenen und erläuterten Korrekturhilfen nutzen.
        </p>

        <p>
            Sodann erfolgt nach Betätigen der Schaltfläche „Zur Kasse“ der Login über ein bereits bestehendes
            Kundenkonto oder die Anmeldung als Neukunde. Eine Bestellung ohne Registrierung ist über den Online-Shop
            nicht möglich. Wünschen Sie keine Registrierung, so wählen Sie bitte eine andere Bestellmethode. Mit dem
            Absenden Ihrer Bestellung durch Anklicken der Schaltfläche „Jetzt kaufen“ geben Sie eine rechtsverbindliche
            Bestellung im Hinblick auf die im Warenkorb befindlichen Waren ab. Ihre Bestellung kann jedoch nur abgegeben
            und an mich übermittelt werden, wenn Sie sich durch Setzen eines entsprechenden Häkchens mit der Geltung
            dieser AGB einverstanden erklären, diese dadurch in Ihre Bestellung aufnehmen und erklären, die
            Verbraucherwiderrufsbelehrung und meine Datenschutzhinweise zur Kenntnis genommen und verstanden zu haben.
        </p>

        <p>
            Nach erfolgreicher Übermittlung Ihrer Bestellung an mich wird Ihnen auf Ihrem Bildschirm eine
            Zusammenfassung Ihrer Bestellung angezeigt; zudem schicke ich Ihnen in diesem Fall eine automatische
            Empfangsbestätigung per E-Mail zu, in welcher Ihre Bestellung nochmals aufgeführt wird. Beides können Sie
            über die Funktion „Drucken“ ausdrucken (jeweils „Bestellbestätigung“). Die Bestellbestätigung dokumentiert
            lediglich, dass Ihre Bestellung bei mir eingegangen ist und stellt keine Annahme Ihres Antrags dar.
        </p>

        <p>
            Der Kaufvertrag kommt bei Bestellungen über den Online-Shop erst durch die Abgabe der Annahmeerklärung durch
            mich, die mit einer gesonderten E-Mail („Auftragsbestätigung“) versandt wird, spätestens jedoch durch
            Lieferung der Ware zustande. Ich kann meine Annahme aber auch gemeinsam bereits mit der Bestellbestätigung
            erklären. Bei Bestellungen per Post, Fax, E-Mail oder Telefon kommt der Kaufvertrag ebenfalls erst durch
            eine Auftragsbestätigung durch mich, welcher per Post, Fax oder E-Mail versandt wird, spätestens jedoch
            durch Lieferung der Bestellten Ware zustande. In der Auftrags- oder Bestellbestätigung oder in einer
            separaten E-Mail, jedoch spätestens bei Lieferung der Ware, wird Ihnen der Vertragstext (bestehend aus
            Bestellung, AGB und Auftragsbestätigung) von mir auf einem dauerhaften Datenträger (E-Mail oder
            Papierausdruck) zugesandt. Der Vertragstext wird unter Wahrung des Datenschutzes gespeichert. Sie können
            Ihre vergangenen Bestellungen unter Ihrem Kundenkonto einsehen, falls Sie ein solches registriert haben. Die
            Registrierung eines Kundenkontos ist keine Bestellvoraussetzung, vgl. oben.
        </p>

        <p>
            Bei der Bestellung verschreibungspflichtiger Produkte steht der Vertragsschluss unter der aufschiebenden
            Bedingung, dass Sie mir ein gültiges Original-Rezept zur Verfügung stellen.
        </p>

        <p>
            Kommt ein Vertragsabschluss nicht zustande, weil Sie mir bei Bestellung rezeptpflichtiger Produkte kein
            gültiges Originalrezept vorlegen, bin ich berechtigt, von einer von Ihnen vorab geleisteten Vorauszahlung
            eine Bearbeitungsgebühr in Höhe von 5 € zzgl. 3% des Auftragswertes einzubehalten. Ihnen bleibt der Nachweis
            eines geringeren Schadens nachgelassen.
        </p>

        <h2>2.3 Vertragssprache</h2>

        <p>Der Vertragsschluss erfolgt in deutscher Sprache.</p>

        <h1>3. Kundenkonto</h1>

        <h2>3.1 Registrierung</h2>

        <p>
            Sie können in meinem Onlineshop ein Kundenkonto registrieren, in das Sie sich mit ihren Zugangsdaten
            einloggen und das Sie hierüber eigenständig verwalten können. Sie sind verpflichtet, bei ihrer Registrierung
            vollständige und richtige Angaben zu machen. Ihr Kundenkonto ist nicht übertragbar. Sie dürfen nicht mehr
            als ein Kundenkonto einrichten und dieses weder vermieten noch verleihen. Ein Anspruch auf Registrierung
            eines Kundenkontos haben Sie nicht.
        </p>

        <h2>3.2 Zugangsdaten</h2>

        <p>
            Sie sind allein für die Sicherheit der Zugangsdaten zu Ihrem Kundenkonto („Zugangsdaten“), verantwortlich,
            insbesondere des Passworts. Dies umfasst insbesondere die strenge Geheimhaltung der Zugangsdaten und deren
            Nichtweitergabe an Dritte. Sollten die Zugangsdaten Unbefugten bekannt geworden sein, sind Sie verpflichtet,
            die Zugangsdaten unverzüglich zu ändern. Ich übernehme keine Haftung für etwaige Schäden im Zusammenhang mit
            der Entwendung der Zugangsdaten, die ich nicht zu vertreten habe, der Weitergabe der Zugangsdaten durch Sie
            oder dem Umstand, dass Sie einem Dritten unter Zuhilfenahme der Zugangsdaten Zugriff auf Ihr Kundenkonto
            gewährt haben. Sie verpflichten sich, mich unverzüglich über jede unbefugte Verwendung der Zugangsdaten zu
            informieren.
        </p>

        <h2>3.3 Deaktivierung</h2>

        <p>
            Sie können Ihr Kundenkonto von mir deaktivieren lassen, indem sie mir eine entsprechende Anfrage per E-Mail
            an meinen Kundenservice senden. Ihr Kundenkonto wird daraufhin deaktiviert. Eine Deaktivierung des
            Kundenkontos erfolgt automatisch, sofern Sie sich innerhalb eines Zeitraums von vier Monaten keine
            Bestellungen tätigen. Etwaige zum Deaktivierungszeitpunkt bestehende Zahlungsverpflichtungen mir gegenüber
            bleiben hiervon unberührt. Eine Reaktivierung des Kundenkontos kann von Ihnen schriftlich gegenüber meinem
            Kundenservice beantragt werden.
        </p>

        <h1>4. Verbraucherwiderrufsrecht</h1>

        <h2>4.1 Widerrufsbelehrung</h2>

        <p>
            Sie haben bei Abschluss eines Fernabsatzgeschäfts grundsätzlich ein gesetzliches Widerrufsrecht, über das
            ich Sie nach Maßgabe des gesetzlichen Musters nachfolgend informiere. Die Ausnahmen vom Widerrufsrecht sind
            in Ziff. 4.2 geregelt. In Ziff. 4.3 findet sich ein Muster-Widerrufsformular.
        </p>

        <div class="legal-form">
            <div class="font-weight-bold text-center">Widerrufsbelehrung</div>

            <b>Widerrufsrecht</b>

            <p>
                Sie haben das Recht, binnen vierzehn Tagen ohne Angaben von Gründen diesen Vertrag zu widerrufen. Die
                Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der
                nicht Beförderer ist, die Waren in Besitz genommen haben bzw. hat. Um Ihr Widerrufsrecht auszuüben,
                müssen Sie mir:
            </p>

            <p>
                apotheke am inselpark
                <br />
                Apotheker Björn Schrage e.K.
                <br />
                Neuenfelder Straße 31
                <br />
                21109 Hamburg
                <br />
                Telefon 040 30238699-0
                <br />
                Telefax 040 30238699-22
                <br />
                Mail info@apotheke-inselpark.de
            </p>

            <p>
                mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief, Telefax oder E-Mail) über
                Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte
                Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist. Zur Wahrung der Widerrufsfrist
                reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der
                Widerrufsfrist absenden.
            </p>

            <b>Folgen des Widerrufs</b>

            <p>
                Wenn Sie diesen Vertrag widerrufen, habe ich Ihnen alle Zahlungen, die ich von Ihnen erhalten habe,
                einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie
                eine andere Art der Lieferung als die von mir angebotene, günstige Standardlieferung gewählt haben),
                unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
                Ihren Widerruf dieses Vertrages bei mir eingegangen ist. Für diese Rückzahlung verwende ich dasselbe
                Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen
                wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung
                Entgelte berechnet. Ich kann die Rückzahlung verweigern, bis ich die Ware wieder zurückerhalten habe
                oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches
                der frühere Zeitpunkt ist. Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn
                Tagen ab dem Tag, an dem Sie mich über den Widerruf dieses Vertrages unterrichten, an mich
                zurückzusenden oder zu übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von
                vierzehn Tagen absenden. Sie tragen die unmittelbaren Kosten der Rücksendung der Waren. Sie müssen für
                einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der
                Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen
                zurückzuführen ist.
            </p>
        </div>

        <h2>4.2 Ausschluss des Widerrufsrechts</h2>

        <p>Ein Widerrufsrecht besteht nicht:</p>

        <p>
            4.2.1 bei Verträgen zur Lieferung versiegelter Waren, die aus Gründen des Gesundheitsschutzes oder der
            Hygiene nicht zur Rückgabe geeignet sind, wenn ihre Versiegelung nach der Lieferung entfernt wurde;
        </p>

        <p>
            4.2.2 bei Verträgen zur Lieferung von Waren, die nicht vorgefertigt sind und für deren Herstellung eine
            individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich ist oder die eindeutig auf die
            persönlichen Bedürfnisse des Verbrauchers zugeschnitten sind; z.B. Rezepturarzneimittel;
        </p>

        <p>
            4.2.3 Verträgen zur Lieferung von Waren, die schnell verderben können oder deren Verfallsdatum schnell
            überschritten würde.
        </p>

        <h2>4.3. Muster-Widerrufsformular</h2>

        <p>Über das Muster-Widerrufsformular informiere ich Sie wie folgt:</p>

        <div class="legal-form">
            <div class="font-weight-bold text-center">Muster-Widerrufsformular</div>

            <p>
                (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es
                zurück.)
            </p>

            <p>An</p>

            <p>
                apotheke am inselpark
                <br />
                Apotheker Björn Schrage e.K.
                <br />
                Neuenfelder Straße 31
                <br />
                21109 Hamburg
                <br />
                Telefax 040 30238699-22
                <br />
                Mail info@apotheke-inselpark.de
            </p>

            <p>
                Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden
                Waren (*)/die Erbringung der folgenden Dienstleistung (*)
            </p>

            <div class="fake-input"></div>
            <p>Bestellt am (*)</p>

            <div class="fake-input"></div>
            <p>erhalten am (*)</p>

            <div class="fake-input"></div>
            <p>Name des/der Verbraucher(s)</p>

            <div class="fake-input"></div>
            <p>Anschrift des/der Verbraucher(s)</p>
            <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</p>

            <div class="fake-input"></div>
            <p>Datum</p>
            <p>(*) Unzutreffendes streichen</p>
        </div>

        <h1>5. Zahlungsbedingungen</h1>

        <h2>5.1 Preise</h2>

        <p>
            Alle Preise, die in meinem Onlineshop angegeben sind, verstehen sich einschließlich der jeweils gültigen
            gesetzlichen Umsatzsteuer.
        </p>

        <h2>5.2 Versandkosten</h2>

        <p>
            Zuzüglich zu den angegebenen Warenpreisen können noch Versandkosten bzw. Kosten für den Botendienst
            anfallen. Die Versandkosten richten sich nach gewähltem Logistiker und sind abhängig vom Bestellwert. Der
            Kunde wird über etwaige anfallende Versandkosten vor Abschluss des Bestellvorganges informiert. Bei Abholung
            in der Apotheke fallen grundsätzlich keine Versandkosten an.
        </p>

        <h2>5.3 Zahlungsarten</h2>

        <p>
            Ich biete Ihnen im Rahmen des Versands die Zahlung auf Rechnung an. Diese Rechnung kann derzeit nur per
            Vorkasse durch den Kunden auf das Konto meiner Apotheke überwiesen oder vor Ort in der Apotheke beglichen
            werden. Der Rechnungsbetrag setzt sich aus den angegebenen Bruttopreisen der einzelnen Produkte
            einschließlich der darin enthaltenen Mehrwertsteuer und zuzüglich eventuell anfallender Versandkosten
            zusammen. Die Verpackung ist im Preis enthalten. Wir behalten uns das Recht vor, die Zahlungsmöglichkeit der
            Rechnung für bestimmte Bestellungen auf Vorkasse zu beschränken.
        </p>

        <h2>5.4 GKV- Patienten</h2>

        <p>
            Bei Vorlage eines ordnungsgemäßen Kassenrezepts erfolgt eine Direktabrechnung mit der gesetzlichen
            Krankenkasse („GKV“), sofern diese eine Direktabrechnung akzeptiert. Bei einer Direktabrechnung mit der GKV
            haben Sie unter Umständen einen Zuzahlungsbetrag sowie einen etwaigen von der GKV nicht übernommenen Anteil
            am Arzneimittelpreis zu zahlen. Jede Lieferung enthält einen Zahlungsbeleg, der bei Ihrer Krankenkasse
            eingereicht werden kann.
        </p>

        <h2>5.5 Zuzahlungsquittungen</h2>

        <p>
            Bitte beachten Sie, dass Preisvorteile, die ich Ihnen auf die verschreibungsfreie Ware gewähre und
            dementsprechend auf dem Zahlungsbeleg ausweise, unter Umständen weder steuerlich berücksichtigt noch Ihnen
            von Ihrer Krankenversicherung erstattet werden.
        </p>

        <h1>6. Lieferbedingungen</h1>

        <h2>6.1 Allgemeines</h2>

        <p>
            Die Lieferung erfolgt an die von Ihnen angegebene Rechnungs- oder eine gegebenenfalls abweichende
            Lieferadresse. Alternativ können Sie Ihre Bestellung auch in meiner Vor-Ort-Apotheke während meiner
            Geschäftszeiten montags bis freitags 9:00-17:30 Uhr abholen, sofern Sie die Option „Pick-Up“ bei Ihrer
            Bestellung ausgewählt oder angegeben haben.
        </p>

        <p>
            Wenn die Ware wegen falscher Adressangaben nicht zugestellt werden kann, Pakete trotz Benachrichtigung nicht
            in der Filiale des Logistikers abgeholt werden oder die Annahme verweigert wird, ohne dass ein Widerruf
            seitens des Kunden vorliegt, behalte ich mir das Recht vor, Ihnen die entstandenen Kosten in Rechnung zu
            stellen.
        </p>

        <p>
            Nehmen Sie die Ware nicht ab, so kann ich nach Ablauf einer Nachfrist von zwei Wochen vom Vertrag
            zurücktreten und ggf. Schadenersatz wegen Nichterfüllung verlangen.
        </p>

        <h2>6.2 Lieferbeschränkungen</h2>

        <p>
            Ich liefere ausschließlich an Kunden, die in der Bundesrepublik Deutschland eine Lieferadresse angeben und
            nur soweit dies die gesetzlichen Bestimmungen ermöglichen. Die Lieferung von nichtverschreibungspflichtiger
            Ware erfolgt nur in haushaltsüblichen Mengen. Die Lieferung der Ware erfolgt durch ein von mir beauftragtes
            Transportunternehmen oder meine Boten. Die Möglichkeit zur Belieferung durch meine Boten wird Ihnen während
            des Bestellvorgangs angezeigt, sofern Ihre Lieferadresse in dem von mir angegebenen Entfernungsbereich
            liegt.
        </p>

        <h2>6.3 Teillieferungen</h2>

        <p>
            Ich bin zu Teillieferungen nur dann berechtigt, soweit dies für Sie zumutbar oder aus Gründen der
            Arzneimittelsicherheit angezeigt ist. Sie tragen dafür Sorge, dass der unter der angegebenen Lieferadresse
            angetroffene volljährige Personenkreis zur Entgegennahme der Lieferung berechtigt ist. Sofern die Zustellung
            aus Gründen fehlschlägt, die Sie zu vertreten haben, tragen Sie die Kosten einer erneuten Zustellung. Sie
            können eine persönliche Zustellung an sich oder an eine bestimmte, von Ihnen angegebene volljährige Person
            verlangen.
        </p>

        <h2>6.4 Lieferfristen</h2>

        <p>
            Sofern für die jeweilige Ware in meinem Onlineshop keine oder keine abweichende Lieferzeit angegeben ist,
            beträgt diese bis zu zwei Werktage (Mo. bis Sa.). Von mir angegebene Lieferzeiten berechnen sich vom
            Zeitpunkt des Vertragsschlusses, vorherige Zahlung des Kaufpreises vorausgesetzt (außer beim Rechnungskauf).
            Ist zum Zeitpunkt Ihrer Bestellung das von Ihnen ausgewählte Produkt nicht oder nicht in der bestellten
            Menge verfügbar, so teile ich Ihnen dies unverzüglich auf geeignetem Wege und bespreche mit Ihnen das
            weitere Vorgehen.
            <b>Für die Lieferung von Arzneimitteln gilt ergänzend und vorrangig Ziff. 6.5.</b>
        </p>

        <h2>6.5 Lieferung von Arzneimitteln</h2>

        <h3>6.5.1 Lieferzeiten</h3>

        <p>
            Ich halte alle Arzneimittel zur Lieferung verfügbar, soweit diese im Geltungsbereich des
            Arzneimittelgesetzes („AMG“) in den Verkehr gebracht werden dürfen und für mich verfügbar sind. Der Versand
            von Arzneimitteln erfolgt innerhalb von zwei Werktagen nach Eingang Ihrer Bestellung bei mir, soweit das
            jeweilige Arzneimittel in dieser Zeit zur Verfügung steht, es sei denn, ich habe mit Ihnen, der das
            Arzneimittel bestellt hat, eine andere Absprache getroffen. Soweit erkennbar ist, dass das bestellte
            Arzneimittel nicht innerhalb einer Frist von zwei Werktagen nach Bestelleingang versendet (oder in unserer
            Vor-Ort-Apotheke abgeholt) werden kann, werde ich Sie unverzüglich in geeigneter Weise davon unterrichten
            und eine Vereinbarung mit Ihnen über die weitere Vorgehensweise treffen. Dies gilt auch für individuell
            verschriebene Rezepturen. Hier prüfe ich im Einzelfall, ob ein Postversand möglich ist.
        </p>

        <h3>6.5.2 Telefonnummer des Kunden</h3>

        <p>
            Die Lieferung von Arzneimitteln auf dem Versandweg setzt voraus, dass Sie bei Ihrer Bestellung eine
            Telefonnummer angegeben haben, unter welcher Sie durch mein pharmazeutisches Personal ohne zusätzliche
            Gebühren während der Geschäftszeiten beraten werden können. Bei der Bearbeitung Ihrer Bestellung können –
            insbesondere zur Abklärung möglicher Wechselwirkungen – Rückfragen bei Ihnen oder Ihrem behandelnden Arzt
            erforderlich werden. Falls Sie Ihrerseits eine pharmazeutische Beratung wünschen, erreichen Sie uns während
            meiner Geschäftszeiten montags bis freitags 9:00-17:30 Uhr unter meiner Hotline: 040 3023 8699 24 oder per
            E-Mail unter:
            <a href="mailto:info@apotheke-inselpark.de">info@apotheke-inselpark.de</a>
        </p>

        <h3>6.5.3 Qualitätssicherungssystem</h3>

        <p>
            Ich unterhalte ein Qualitätssicherungssystem und verpacke zu versendende Arzneimittel so, dass deren
            Qualität und Wirksamkeit erhalten bleibt. Die Lieferung kühlpflichtiger Arzneimittel erfolgt bei Bedarf aus
            Gründen der Arzneimittelsicherheit mit speziellen Kühlfahrzeugen. Die erfolgreiche Zustellung von
            Arzneimittellieferungen wird durch Unterschrift quittiert. Aus Gründen der Arzneimittelsicherheit werden
            Arzneimittellieferungen nur an volljährige Personen ausgehändigt. Bei Bestellung von Betäubungsmitteln wird
            als ausschließlich berechtigte Empfängerin die Person bestimmt, der das Betäubungsmittel verordnet wurde.
            Sollte diese Person aus wichtigem Grund (z.B. körperliche Beeinträchtigungen) nicht in der Lage sein, das
            Paket persönlich entgegenzunehmen, so kann vor Versand eine bevollmächtigte Person schriftlich benannt und
            der Apotheke mitgeteilt werden. Ohne Bestätigung der Apotheke ist die Bevollmächtigung unwirksam.
        </p>

        <h3>6.5.4 Verschreibungspflichtige Arzneimittel; Pickup</h3>

        <p>
            Verschreibungspflichtige Arzneimittel können erst nach Erhalt und Prüfung des gültigen (Original-)Rezeptes
            durch mich versendet werden. Schicken Sie Ihr Originalrezept bitte an:
            <b>apotheke am inselpark, Neuenfelder Straße 31, 21109 Hamburg</b>
            . Vorabbestellungen zur Selbstabholung in meiner Vor-Ort-Apotheke erfordern keine postalische Übermittlung
            des Rezepts. Sie können das Original-Rezept bei Abholung in meiner Vor-Ort-Apotheke abgeben. Bei Lieferung
            verschreibungspflichtiger Arzneimittel im Rahmen meines Botendienstes ist das Originalrezept vor Abgabe der
            Arzneimittel meinem Boten (pharm. Personal) zu übergeben und wird von diesem geprüft oder das Originalrezept
            ist mir vorab vorzulegen (z.B. in meiner Vor-Ort-Apotheke oder per Post zu übersenden).
        </p>

        <h3>6.5.5 Wirkstoffgleiche Austauschprodukte; Reimporte</h3>

        <p>
            Aufgrund geltenden Rechts oder entsprechender Vereinbarungen mit den gesetzlichen Krankenkassen kann ich
            berechtigt bzw. verpflichtet sein, für bestimmte Arzneimittel wirkstoffgleiche Austauschprodukte oder
            Reimporte zu liefern. Solche Lieferungen entsprechen dem Liefervertrag und sind daher insoweit weder als
            Falschlieferung noch als mangelhafte Lieferung zu werten.
        </p>

        <h3>6.5.6 Arzneimittelsicherheit</h3>

        <p>
            Ich darf die Abgabe eines Arzneimittels ablehnen, wenn zu dessen sicheren Anwendung ein Informations- oder
            Beratungsbedarf besteht, der auf einem anderen Wege als einer persönlichen Information oder Beratung durch
            einen Apotheker nicht erfolgen kann. Ich bin berechtigt, eine Abgabe bei begründetem Verdacht auf
            Arzneimittelmissbrauch oder aus sonstigen zwingenden Gründen der Arzneimittelsicherheit zu verweigern. Aus
            Gründen der Arzneimittelsicherheit können für bestimmte Arzneimittel, wie z.B. Schlaf- oder Schmerzmittel,
            zudem bestimmte Höchstabgabemengen gelten. Die abzugebende Menge wird sodann auf die gesetzlich zulässige
            Menge verringert; der von Ihnen zu zahlende Betrag verringert sich entsprechend. Folgende Arzneimittel
            dürften in der Bundesrepublik Deutschland nicht auf dem Versandweg abgegeben werden und sind bei uns daher
            online nicht erhältlich: Arzneimittel, für die ein sogenanntes T-Rezept erforderlich ist;
            Notfall-Kontrazeptiva („Pille danach“) sowie verschreibungspflichtige Tierarzneimittel und Arzneimittel für
            Tiere, die der Lebensmittelgewinnung dienen.
        </p>

        <h1>7. Sachmängelgewährleistung, Garantie; Eigentumsvorbehalt</h1>

        <p>
            Ich hafte für Sachmängel nach den hierfür geltenden gesetzlichen Vorschriften. Eine zusätzliche Garantie
            besteht bei den von mir gelieferten Waren nur, wenn diese ausdrücklich in der Bestellbestätigung zu dem
            jeweiligen Artikel abgegeben wurde. Bis zur vollständigen Bezahlung verbleiben die gelieferten Waren in
            meinem Eigentum.
        </p>

        <h1>8. Haftung</h1>

        <h2>8.1 Haftungsbeschränkung</h2>

        <p>
            Ihre Ansprüche auf Schadensersatz sind ausgeschlossen. Hiervon ausgenommen sind Ihre Schadensersatzansprüche
            aus der Verletzung des Lebens, des Körpers, der Gesundheit oder aus der Verletzung wesentlicher
            Vertragspflichten (Kardinalpflichten) sowie die Haftung für sonstige Schäden, die auf meiner vorsätzlichen
            oder grob fahrlässigen Pflichtverletzung, meiner gesetzlichen Vertreter oder Erfüllungsgehilfen beruhen.
            Wesentliche Vertragspflichten sind solche, deren Erfüllung zur Erreichung des Ziels des Vertrags notwendig
            ist. Zwingende gesetzliche Haftungstatbestände z.B. aufgrund des Produkthaftungs- oder Arzneimittelgesetzes
            bleiben unberührt.
        </p>

        <h2>8.2 Verletzung wesentlicher Vertragspflichten</h2>

        <p>
            Bei der Verletzung wesentlicher Vertragspflichten hafte ich nur auf den vertragstypischen, vorhersehbaren
            Schaden, wenn dieser einfach fahrlässig verursacht wurde, es sei denn, es handelt sich um
            Schadensersatzansprüche von Ihnen aus einer Verletzung des Lebens, des Körpers oder der Gesundheit.
        </p>

        <h2>8.3 Gesetzliche Vertreter und Erfüllungsgehilfen</h2>

        <p>
            Die Einschränkungen der Ziff. 8.1 und 8.2 gelten auch zugunsten meiner gesetzlichen Vertreter und
            Erfüllungsgehilfen, wenn Ansprüche direkt gegen diese geltend gemacht werden.
        </p>

        <h1>9. Sonstiges</h1>

        <h2>9.1 Urheberrechte</h2>

        <p>
            Sämtliche Bilder, Fotos, Filme und Texte, die im Onlineshop veröffentlicht werden, sind urheberrechtlich
            geschützt. Ihre Verwendung ist ohne die ausdrückliche vorherige schriftliche Zustimmung des jeweiligen
            Rechteinhabers nicht gestattet.
        </p>

        <h2>9.2 Ergänzende Bedingungen für die Nutzung meiner Internetseiten</h2>

        <p>
            Die Nutzung meiner Internetseiten unterliegt ergänzend den nachfolgenden Nutzungsbedingungen. Sie dürfen
            meine Internetseiten nicht nutzen, sofern Sie diese Nutzungsbedingungen nicht akzeptieren. Durch Nutzung
            meiner Internetseiten kommt zwischen Ihnen und mir ein unentgeltlicher Vertrag zur Nutzung meiner
            Internetseiten zustande. Eine ununterbrochene und vollumfängliche Verfügbarkeit meiner Internetseiten kann
            nach dem derzeitigen Stand der Technik nicht gewährleistet werden. Ich hafte daher nicht für die ständige
            und ununterbrochen fehlerfreie Verfügbarkeit meiner Internetseiten. Störungen oder Wartungsarbeiten könne
            deren Nutzungsmöglichkeit einschränken oder zeitweise unterbrechen. Soweit ich Einfluss auf Unterbrechungen
            habe (z.B. bei Wartungsarbeiten), bin ich bemüht, solche Unterbrechungen möglichst kurz zu halten. Die
            Nutzung meiner Internetseiten kann mittels Personal Computer (PC) über einen Webbrowser im Internet am
            besten per DSL oder mittels eines gleichwertigen Anschlusses erreicht werden. Erfolgt die Nutzung über
            sonstige internetfähige Endgeräte, können sowohl Funktionsumfang als auch Darstellung eingeschränkt sein.
            Ich übernehme keine Gewähr für die Datensicherheit außerhalb meines Herrschaftsbereichs und die Gefahr von
            Datenverlust bei der Übertragung von Daten über das Internet.
        </p>

        <h2>9.3 Zurückbehaltungsrechte; Aufrechnung</h2>

        <p>
            Sie sind zur Aufrechnung gegen meine Ansprüche nur berechtigt, wenn Ihre Forderungen rechtskräftig
            festgestellt wurden, ich diese anerkannt habe oder wenn Ihre Forderungen unstreitig sind. Zur Aufrechnung
            gegen meine Ansprüche sind Sie auch berechtigt, wenn Sie Mängelrügen oder Gegenansprüche aus demselben
            Kaufvertrag geltend machen. Als Käufer dürfen Sie ein Zurückbehaltungsrecht nur dann ausüben, wenn Ihr
            Gegenanspruch auf demselben Kaufvertrag beruht.
        </p>

        <h2>9.4 Anwendbares Recht</h2>

        <p>
            Es gelten die bei Vertragsschluss jeweils aktuelle Fassung meiner AGB sowie das Recht der Bundesrepublik
            Deutschland. Die Bestimmungen des UN-Kaufrechts finden keine Anwendung. Die gesetzlichen Vorschriften zur
            Beschränkung der Rechtswahl und zur Anwendbarkeit zwingender Vorschriften insbesondere des Staates, in dem
            Sie als Verbraucher Ihren gewöhnlichen Aufenthalt haben, bleiben unberührt.
        </p>

        <h2>9.5 Gerichtsstand</h2>

        <p>
            Wenn Sie keinen Wohnsitz in der Bundesrepublik Deutschland haben oder Ihr gewöhnlicher Aufenthaltsort zum
            Zeitpunkt der Klageerhebung nicht bekannt ist, ist mein Geschäftssitz ausschließlicher Gerichtsstand für
            alle sich aus dem Vertragsverhältnis unmittelbar oder mittelbar ergebenden Streitigkeiten.
        </p>

        <h2>9.6 Streitbeilegung</h2>

        <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter
            <a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a>
            finden. Zur Teilnahme an einem Streit- beilegungsverfahren vor einer Verbraucherschlichtungsstelle bin ich
            weder verpflichtet noch bereit. Meine E-Mail-Adresse finden sie oben unter Ziff. 1.1 oder im Impressum
            meiner Internetseiten.
        </p>

        <p>Stand dieser AGB: 24.03.2024</p>
    </div>
</template>
